import React from 'react';
import { Button, ButtonTheme } from '@apply/components';
import { useNavigate } from 'react-router';
import { isMobileScreen } from '@apply/ui';

export const AddExperienceButton: React.FC = () => {
    const mobileScreen = isMobileScreen();
    const navigate = useNavigate();

    const handleAddExperienceButtonClick = () => {
        navigate('/experience/property');
        window.scrollTo(0, 0);
    };

    return (
        <Button
            id='addExperienceButton'
            theme={ButtonTheme.Primary}
            width={mobileScreen ? '100%' : '250px'}
            height='36px'
            handleClick={handleAddExperienceButtonClick}
        >
            Add Experience
        </Button>
    );
};
